var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2854 13.5951C11.1201 12.7822 9.70288 12.3056 8.17427 12.3056C4.47847 12.3056 1.43355 15.0923 1.02616 18.6791C0.997328 18.933 0.982909 19.0599 1.03359 19.1825C1.07506 19.2827 1.16483 19.3832 1.25979 19.4358C1.37585 19.5 1.51793 19.5 1.80207 19.5H7.08971M11.2576 17.7381L13.1076 19.5L17.4243 15.3889M12.2854 5.11111C12.2854 7.38162 10.4448 9.22222 8.17427 9.22222C5.90379 9.22222 4.06318 7.38162 4.06318 5.11111C4.06318 2.84061 5.90379 1 8.17427 1C10.4448 1 12.2854 2.84061 12.2854 5.11111Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentIcon);
export default __webpack_public_path__ + "static/media/agentIcon.12694ab3ba0b1c0afd60d29615116821.svg";
export { ForwardRef as ReactComponent };